import React, { useEffect, useRef } from "react";

// Search Icon
export const SearchIcon = () => (
  <svg viewBox="64 64 896 896" fill="currentColor" width="1em" height="1em">
    <path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path>
  </svg>
);

const SearchDropdown = ({
  isOpen,
  onClose,
  onSearch,
  searchTerm,
  setSearchTerm,
  loading,
  position,
}) => {
  const dropdownRef = useRef(null);

  useEffect(
    function () {
      const handleClickOutside = function (event) {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          onClose();
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return function () {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    },
    [onClose],
  );

  if (!isOpen) return null;

  const handleReset = function () {
    setSearchTerm("");
    onClose();
  };

  return (
    <div
      ref={dropdownRef}
      className="absolute bg-white rounded shadow-lg z-50 p-2"
      style={{
        top: position.top,
        left: position.left,
        boxShadow:
          "0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)",
        minWidth: "250px",
      }}
    >
      <input
        placeholder="Search username"
        className="w-full border border-gray-300 px-3 py-2 mb-2 focus:outline-none focus:border-blue-500"
        type="text"
        value={searchTerm}
        onChange={function (e) {
          setSearchTerm(e.target.value);
        }}
        onKeyPress={function (e) {
          if (e.key === "Enter") {
            onSearch();
          }
        }}
        autoFocus
      />
      <div className="flex gap-2">
        <button
          type="button"
          className="flex-1 bg-blue-500 text-white px-4 py-1.5 text-sm hover:bg-blue-600 flex items-center justify-center gap-1"
          onClick={onSearch}
          disabled={loading}
        >
          <SearchIcon />
          <span>{loading ? "Searching..." : "Search"}</span>
        </button>
        <button
          type="button"
          className="flex-1 bg-gray-500 text-white px-4 py-1.5 text-sm hover:bg-gray-600"
          onClick={handleReset}
        >
          Reset
        </button>
      </div>
    </div>
  );
};

export default SearchDropdown;
